import {connectToggleRefinement} from 'instantsearch.js/es/connectors';

const renderToggleRefinement = (renderOptions, isFirstRender) => {
    const {value, refine, widgetParams} = renderOptions;

    if (isFirstRender) {
        widgetParams.container.className = 'ais-ToggleRefinement';
        const label = document.createElement('label');
        label.className = 'ais-ToggleRefinement-label wcag-focus';

        const input = document.createElement('input');
        input.className = 'ais-ToggleRefinement-checkbox';
        input.type = 'checkbox';

        const span = document.createElement('span');
        span.className = 'ais-ToggleRefinement-labelText';
        span.appendChild(document.createTextNode(widgetParams.translations['algolia.search.filter.title.' + widgetParams.attribute]));

        input.addEventListener('change', event => {
            refine({isRefined: !event.target.checked});
        });

        label.appendChild(input);
        label.appendChild(span);

        widgetParams.container.appendChild(label);
    }

    const input = widgetParams.container.querySelector('input');

    input.checked = value.isRefined;
    input.ariaChecked = value.isRefined;
};

// Create the custom widget
const customToggleRefinement = connectToggleRefinement(
    renderToggleRefinement
);

export {customToggleRefinement};
